import { openapi } from "../openapi";

export const MCBIM_VIEWER_CACHE_TAG = "McbimViewer";

export const mcbimViewerApi = openapi.enhanceEndpoints({
  addTagTypes: [MCBIM_VIEWER_CACHE_TAG],
  endpoints: {
    getMcbimFloors: {
      providesTags: [MCBIM_VIEWER_CACHE_TAG],
    },
    getMcbimFurnitureAndWallsOnFloor: {
      providesTags: [MCBIM_VIEWER_CACHE_TAG],
    },
    getMcbimItemsInSpace: {
      providesTags: [MCBIM_VIEWER_CACHE_TAG],
    },
    getMcbimSpace: {
      providesTags: [MCBIM_VIEWER_CACHE_TAG],
    },
    getMcbimSpaces: {
      providesTags: [MCBIM_VIEWER_CACHE_TAG],
    },
    getMcbimSpacesOnFloor: {
      providesTags: [MCBIM_VIEWER_CACHE_TAG],
    },
  },
});
